import React from "react";
import ReactDOM from "react-dom/client";
import "material-icons/iconfont/outlined.css";
import "@fontsource/inter/400.css";
import "@fontsource/inter/500.css";
import "@fontsource/inter/600.css";
import "@fontsource/inter/700.css";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import ContextWrapper from "./context/ContextWrapper";
import { ThemeProvider } from "./context/ThemeContext";
import { AuthProvider } from "react-oauth2-code-pkce";


const authConfig = {
    clientId: window.env.AUTH_CLIENT_ID,
    authorizationEndpoint: window.env.AUTH_AUTHORIZATION_ENDPOINT,
    logoutEndpoint: window.env.AUTH_LOGOUT_ENDPOINT,
    tokenEndpoint: window.env.AUTH_TOKEN_ENDPOINT,
    logoutEndpoint: window.env.AUTH_LOGOUT_ENDPOINT,
    redirectUri: window.env.AUTH_REDIRECT_URI,
    scope: window.env.AUTH_SCOPES,
    onRefreshTokenExpire: (event) => window.confirm('Session expired. Refresh page to continue using the site?') && event.login(),
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <AuthProvider authConfig={authConfig}>
    <ThemeProvider>
      <ContextWrapper>
        <App />
      </ContextWrapper>
    </ThemeProvider>
  </AuthProvider>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
